export default __webpack_public_path__ + "static/media/clientes.366eba8f.png";